<script setup lang="ts">
import { computed } from 'vue'
import type { DailyPanelProps } from '@/ui/daily-panel'
import { expChartCopy } from '@/i18n/exp-chart'
import { presentExpChartEmpty } from '@/ui/exp-chart-empty'
import ExpRateChart from '../ExpRateChart.vue'
const props = defineProps<Pick<DailyPanelProps, 'data' | 'locale'>>()
const empty = computed(() => presentExpChartEmpty(props.data.status, props.data.expChart, props.locale))
</script>
<template>
  <div class="daily-chart order-chart">
    <ExpRateChart widget :show-readout="false" :model="data.expChart" :locale="locale" :rate-unit="data.rateUnit">
      <template #empty>
        <div class="daily-chart-empty" :title="empty.description" :aria-label="empty.description" role="img" tabindex="0">
          <span class="daily-chart-empty-heading">{{ expChartCopy[locale].title }}</span>
          <span class="daily-chart-empty-status"><span>{{ empty.label }}</span><span v-if="empty.samples" class="daily-chart-empty-samples">{{ empty.samples }}</span></span>
        </div>
      </template>
    </ExpRateChart>
  </div>
</template>
